export const TYPES_CONTRAT_JOUEURS = [
    "type contrat 1",
    "type contrat 2",
    "type contrat 3"
]



// WEBPACK FOOTER //
// ./src/data/types_contrat_joueurs.js